import { GET_USERS, REFRESH_USERS, IS_LOADING_USERS } from "../actions/users";

const INITIAL_STATE = {
  users: [],
  refresh: true,
  isLoading: false,
};

const usersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload.users,
        // displayName: action.payload.displayName,
      };
    case REFRESH_USERS:
      return {
        ...state,
        refresh: action.payload,
      };

    case IS_LOADING_USERS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        // displayName: action.payload.displayName,
      };

    default:
      return state;
  }
};

export default usersReducer;
